
import { useNavigate, useParams } from "react-router-dom";
import { Section } from "../components/styled/Containers.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { Vspace } from '../components/styled/Separators.style'
import { composeUrl } from "../utils/utils";
import { PATHS } from "../routes/CaiExperienceRouter";
import PageContainerCmp from "./PageContainerCmp";
import FotoCruscotto from "../components/foto-cruscotto/FotoCruscotto";
import { useAppSelector } from "../store/hooks";
import { selectCommunicationData } from "../store";

/* istanbul ignore next */
const Trct_FotoCruscottoPage = () => {
    let navigate = useNavigate();
    let { token } = useParams();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const nextBtnDisabled = !communication?.fotoCruscotto || communication.fotoCruscotto.length < 1;

    const goToNextStepHandler = () => {
        navigate(composeUrl(token, PATHS.TRCT_FOTO_CARTA_CIRCOLAZIONE))
    }

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.TRCT_FOTO_CRUSCOTTO}
                nextDisabled={nextBtnDisabled}
            >
                <>
                    <Section>
                        <PageTitle>Foto del cruscotto</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>Accendi il motore e scatta una fotografia del cruscotto. Questo ci permette di verificare il chilometraggio del veicolo e di individuare eventuali spie accese.</TextDefault>
                    </Section>

                    <FotoCruscotto
                        onTotFotoIsRiched={goToNextStepHandler} />
                </>
            </PageContainerCmp>
        </>

    )
}

export default Trct_FotoCruscottoPage